<template>
    <div id="app">
        <!-- 路由占位符 -->
        <router-view />
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },

    created() {},
    beforeDestroy() {},
    methods: {}
}
</script>

<style lang="less">
#app {
}
</style>
